import { render } from "./ViewLoader.vue?vue&type=template&id=4d27804e"
import script from "./ViewLoader.vue?vue&type=script&lang=js"
export * from "./ViewLoader.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/actions-runner/_work/frontend/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__